import { HmfBreadcrumbsComponent, HmfDividerComponent } from '@dsg-tech/homefield-angular';

import { BreadCrumbsComponent } from './breadcrumbs.component';
import { CommonModule } from '@angular/common';
import { HomefieldButtonModule } from '@homefield';
import { NgModule } from '@angular/core';

/** @format */





@NgModule({
	declarations: [BreadCrumbsComponent],
	imports: [
		CommonModule,
		HmfBreadcrumbsComponent,
		HmfDividerComponent,
		HomefieldButtonModule,
	],
	providers: [],
	exports: [BreadCrumbsComponent]
})
export class BreadCrumbsModule {}
